export default __webpack_public_path__ + "static/cross-border-payment-solutions-1-87d52f7c40d8610f856027fcc9518e47.png";